<template>
  <AdminLayout><PackedOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import PackedOrdersTable from './PackedOrdersTable.vue';

export default {
  name: 'PackedOrders',
  components: { AdminLayout, PackedOrdersTable },
};
</script>
